export default __webpack_public_path__ + "static/media/feature-box-collection-iranian-cinema-550x310.05e06a6c.jpg";